import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialListsState } from './initialState'
import type { ImportMode } from './types'

const slice = createSlice({
  name: 'userLists/lists',
  initialState: initialListsState,
  reducers: {
    openCreateModal: state => {
      state.createModalOpen = true
    },
    closeCreateModal: state => {
      state.createModalOpen = false
    },
    openImportModeModal: (state, action: PayloadAction<number>) => {
      state.importModeModalOpen = true
      state.importerListId = action.payload
    },
    closeImportModeModal: state => {
      state.importModeModalOpen = false
      state.importMode = null
    },
    confirmImportMode: (state, action: PayloadAction<ImportMode>) => {
      state.importMode = action.payload
      state.importModeModalOpen = false
      state.importerOpen = true
    },
    openImporter: (state, action: PayloadAction<number>) => {
      state.importerOpen = true
      state.importerListId = action.payload
    },
    closeImporter: state => {
      state.importerOpen = false
      state.importerListId = null
      state.importMode = null
    },
    setActiveImportFileUploadId: (
      state,
      action: PayloadAction<number | null>
    ) => {
      state.activeImportFileUploadId = action.payload
    },
  },
})

export const reducer = slice.reducer
export const {
  openCreateModal,
  closeCreateModal,
  openImportModeModal,
  closeImportModeModal,
  confirmImportMode,
  openImporter,
  closeImporter,
  setActiveImportFileUploadId,
} = slice.actions

// Selectors
type UserListsRootState = {
  userLists: { lists: ReturnType<typeof reducer> }
}

export const selectCreateModalOpen = (state: UserListsRootState) =>
  state.userLists.lists.createModalOpen

export const selectImportModeModalOpen = (state: UserListsRootState) =>
  state.userLists.lists.importModeModalOpen

export const selectImportMode = (state: UserListsRootState) =>
  state.userLists.lists.importMode

export const selectImporterOpen = (state: UserListsRootState) =>
  state.userLists.lists.importerOpen

export const selectImporterListId = (state: UserListsRootState) =>
  state.userLists.lists.importerListId

export const selectActiveImportFileUploadId = (state: UserListsRootState) =>
  state.userLists.lists.activeImportFileUploadId

export type { ListsState, ImportMode } from './types'
